import type { HubTheme } from "../hub-theme.types";

// STAGE has no prototype of its own — the tokens below are transcribed from
// ../stage.ts (mono graphite on white) onto the same light structure FITUP
// uses, so the hub matches the rest of the STAGE build.
const GRAPHITE_SHEEN =
  "linear-gradient(135deg, #0F0F10 0%, #2A2A2B 45%, #5B5A59 72%, #2A2A2B 100%)";

export const stageHubTheme: HubTheme = {
  wordmark: "STAGE",
  wordmarkLabel: "STAGE",
  pageBackground: "#FFFFFF",

  heroBg: GRAPHITE_SHEEN,
  heroStripe: undefined,
  heroGlow:
    "radial-gradient(closest-side, rgba(255,255,255,0.20) 0%, rgba(255,255,255,0) 70%)",
  greetingText: "rgba(255,255,255,0.70)",
  nameText: "#FFFFFF",
  pillBg: "rgba(255,255,255,0.12)",
  pillBorder: "rgba(255,255,255,0.20)",
  pillText: "#FFFFFF",
  codeText: "rgba(255,255,255,0.78)",
  watermark: "rgba(255,255,255,0.07)",

  avatarRing: "linear-gradient(135deg, #5B5A59 0%, #FFFFFF 100%)",
  avatarInnerBg: "linear-gradient(135deg, #2A2A2B 0%, #0F0F10 100%)",
  avatarText: "#FFFFFF",

  loyaltyStripBg: "rgba(255,255,255,0.10)",
  loyaltyStripBorder: "rgba(255,255,255,0.16)",
  loyaltyFill:
    "linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0.65) 100%)",
  loyaltyText: "#FFFFFF",
  loyaltyMuted: "rgba(255,255,255,0.72)",

  surface: "#FFFFFF",
  surface2: "#F5F5F5",
  tileBg: "#FAFAFA",
  fg: "#0F0F10",
  fgSoft: "#2A2A2B",
  muted: "#797677",
  muted2: "#8E8A86",
  border: "#E5E1E1",
  borderSoft: "#EEEEEE",

  brand: "#0F0F10",
  brandSoft: "#F1F1F1",
  brandStrong: "#2A2A2B",
  cream: "#0F0F10",
  gradient: GRAPHITE_SHEEN,
  qrIconBg: "#0F0F10",
  memStripe: "linear-gradient(180deg, #0F0F10 0%, #5B5A59 100%)",

  eyebrowRule: "#0F0F10",
  eyebrowText: "#5B5A59",
  metaText: "#2A2A2B",
  metaBg: "#F1F1F1",
  metaBorder: "transparent",

  danger: "#BA1A1A",
  dangerSoft: "#FCE7EA",
  star: "#F18230",
  success: "#2E7D32",
  successSoft: "#F5FEE9",
  warning: "#ED6C02",
  warningSoft: "#FDF5E8",
  cardShadow: "0px 1px 2px rgba(0,0,0,0.04)",
  ctaShadow: "0px 4px 12px rgba(0,0,0,0.25)",
  heroShadow: "0 12px 30px -8px rgba(15,15,16,0.35)",
  heroBorder: "rgba(255,255,255,0.14)",
  avatarShadow:
    "0 8px 22px rgba(15,15,16,0.28), inset 0 1px 0 rgba(255,255,255,0.35)",

  activityIcons: [
    {
      bg: "#0F0F10",
      color: "#fff",
      shadow: "0 4px 10px rgba(15,15,16,0.28)",
    },
    { bg: "linear-gradient(135deg, #2A2A2B 0%, #5B5A59 100%)", color: "#fff" },
    { bg: "#F1F1F1", color: "#0F0F10" },
    { bg: "#F5F5F5", color: "#2A2A2B" },
  ],
};
